<script setup lang="ts">
  import type { IAnchor } from '@/components/ui/anchor/type'

  const props = defineProps<{ blok: any }>()

  const anchors = computed(() => {
    const data: IAnchor[] = []

    props.blok.sections.forEach((section: any) => {
      if (!section.content?.anchor) return

      data.push({
        href: section.content.anchor,
        text: section.content.title
      })
    })

    return data
  })
</script>

<template>
  <section
    v-editable="blok"
    class="flex flex-col gap-10"
  >
    <h3 v-if="blok.title">{{ blok.title }}</h3>

    <UiAnchor
      v-if="anchors.length"
      :anchors="anchors"
    />

    <section
      v-for="{ content, _uid } in blok.sections"
      :id="content.anchor"
      :key="_uid"
      class="grid scroll-mt-16 md:scroll-mt-36"
    >
      <h2 v-if="content.title">{{ content.title }}</h2>

      <div class="grid gap-10 sm:gap-20">
        <UiSiloSection
          v-if="content.large.length"
          :content="content.large"
          size="large"
        />

        <UiSiloSection
          v-if="content.medium.length"
          :content="content.medium"
          size="medium"
        />

        <UiSiloSection
          v-if="content.small.length"
          :content="content.small"
          size="small"
        />
      </div>

      <hr
        v-if="content.showDivider"
        class="mt-20"
      />
    </section>
  </section>
</template>
